<template>
  <div class="app-box" id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
}
</script>

<style>
body {
  font-family: PingFang SC, PingFang-SC-Regular, Helvetica Neue, Helvetica, Arial, Microsoft Yahei, Hiragino Sans GB, Heiti SC, WenQuanYi Micro Hei, sans-serif;
  margin: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  background-color: #fff;
  font-feature-settings: "tnum";
  display: block;
}

body,
html {
  width: 100%;
}

*,
:after,
:before {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
</style>
